import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import DE from "utils/translations/de.json";

import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css";

import Root from "./Root";

import "./index.scss";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "DE",
  fallbackLng: "DE",
  resources: {
    DE: { common: DE },
  },
});

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#583dff" },
    secondary: { main: "#cb97ff" },
    background: { default: "#fafafa" },
    text: { primary: "#2c2936" },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  shape: { borderRadius: 12 },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <I18nextProvider i18n={i18next}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </ThemeProvider>
  </I18nextProvider>,
);
